import { render, staticRenderFns } from "./website-success-stories-banner.vue?vue&type=template&id=5cff436e&scoped=true"
import script from "./website-success-stories-banner.vue?vue&type=script&lang=js"
export * from "./website-success-stories-banner.vue?vue&type=script&lang=js"
import style0 from "./website-success-stories-banner.vue?vue&type=style&index=0&id=5cff436e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff436e",
  null
  
)

export default component.exports